import React from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import {
  deepSetObject, digObject, toggleArray,
} from '@domain-group/javascript-utils'

import { Button, DashboardModule } from '@domain-group/suit-theme'

import handleCallbackAction from '@functions/handleCallbackAction'

import TemplatePage from './TemplatePage'

const deleteTemplatePage = (templatePage, options, updateFn) => {
  const templatePages = digObject(options, 'template.pages', [])

  const updatedArray = toggleArray(templatePages, templatePage, { deepCompare: true })
  const entityParams = { options: deepSetObject(options, 'template.pages', updatedArray) }

  handleCallbackAction({
    callbacks: {
      action: updateFn,
    },
    entityParams,
    toastText: 'Template Page Deleted',
  })
}

const TemplatePages = (props) => {
  const { serviceProductPayload } = props

  const {
    callbacks: {
      addTemplatePage,
      updateServiceProduct: updateFn,
    },
    loading,
    serviceProduct: {
      options,
    },
  } = serviceProductPayload

  const templatePages = digObject(options, 'template.pages', [])
  const hasTemplatePages = !!templatePages.length

  return (
    <DashboardModule contentBoxProps={{ flexDirection: 'column' }} loading={loading} title="Template Pages">
      {hasTemplatePages && (
        <DashboardModule.ScrollableSection>
          {templatePages.map(templatePage => (
            <TemplatePage
              key={templatePage.title}
              callbacks={{ deleteTemplatePage: () => deleteTemplatePage(templatePage, options, updateFn) }}
              templatePage={templatePage}
            />
          ))}
        </DashboardModule.ScrollableSection>
      )}

      <DashboardModule.Footer
        boxProps={{
          borderTop: !hasTemplatePages ? 'none' : '1px solid',
        }}
      >
        <DashboardModule.FooterRight>
          <Button
            buttonStyle="secondaryEdit"
            icon={<FontAwesomeIcon icon={faPlus} />}
            onClick={() => addTemplatePage()}
            size={['medium', 'small']}
            width={['100%', 'fit-content']}
          >
            Create Page
          </Button>
        </DashboardModule.FooterRight>
      </DashboardModule.Footer>
    </DashboardModule>
  )
}

TemplatePages.propTypes = {
  serviceProductPayload: PropTypes.shape({
    callbacks: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    serviceProduct: PropTypes.object.isRequired,
  }),
}

export default TemplatePages
